import { render } from "./lipidAnalyzer_calculator.vue?vue&type=template&id=d87a3488&scoped=true"
import script from "./lipidAnalyzer_calculator.vue?vue&type=script&lang=js"
export * from "./lipidAnalyzer_calculator.vue?vue&type=script&lang=js"

import "./lipidAnalyzer_calculator.vue?vue&type=style&index=0&id=d87a3488&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87a3488"]])

export default __exports__